/* Elementi sitewide storefront engagement contract v1.
 * Consent-gated, no generic autocapture, no PII or raw URLs/form values.
 * This measures normal storefront pages only. Shopify Customer Events owns
 * checkout-step measurement; Shopify Admin orders remain purchase truth.
 */
(function (w) {
  'use strict';
  var VERSION = 'elementi-engagement-v1';
  var PAGE = (w.location.pathname || '/').replace(/\/$/, '') || '/';
  var SENSITIVE = /^\/(?:account|accounts|checkout|checkouts|orders|apps)(?:\/|$)/.test(PAGE);
  var VARIANT = '44405736079405';
  var storageKey = 'elementi_engagement_exposure_v1';
  var entryStorageKey = 'elementi_site_entry_v1';
  var visitorStorageKey = 'elementi_site_visitor_v1';
  var sent = Object.create(null), exposure = null, maxScroll = 0, performance = { lcp: null, cls: 0, inp: null };
  var scrollSignal = { lastY: w.scrollY || 0, direction: null, directionalStartY: w.scrollY || 0, reversals: 0 };
  var unresolvedControlClicks = 0;

  function allowed() { try { return w.Shopify && w.Shopify.customerPrivacy && w.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; } }
  function internal() { return !!(w.Shopify && w.Shopify.designMode) || !!navigator.webdriver || /bot|crawler|spider|headless/i.test(navigator.userAgent || ''); }
  function usable() { return !SENSITIVE && !internal() && allowed() && w.posthog && typeof w.posthog.capture === 'function'; }
  function id(prefix) { var a = new Uint8Array(16); w.crypto.getRandomValues(a); return prefix + Array.prototype.map.call(a, function (n) { return n.toString(16).padStart(2, '0'); }).join(''); }
  function valid(v) { return typeof v === 'string' && /^[A-Za-z0-9_-]{1,120}$/.test(v); }
  function text(v, max) { v = String(v || '').trim(); return v && v.length <= max && !/@/.test(v) ? v : null; }
  function browser() {
    var ua = navigator.userAgent || '';
    if (/Instagram/i.test(ua)) return 'instagram_in_app';
    if (/FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(ua)) return 'facebook_in_app';
    if (/Edg\//i.test(ua)) return 'edge';
    if (/CriOS|Chrome\//i.test(ua)) return 'chrome';
    if (/Firefox\//i.test(ua)) return 'firefox';
    if (/Safari\//i.test(ua)) return 'safari';
    return 'other';
  }
  function device() {
    if (matchMedia('(max-width: 767px)').matches) return 'mobile';
    if (matchMedia('(max-width: 1023px)').matches) return 'tablet';
    return 'desktop';
  }
  function referrerHost() { try { return new URL(document.referrer).hostname.toLowerCase() || null; } catch (_) { return null; } }
  function utm() {
    var q = new URLSearchParams(w.location.search), result = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      var value = text(q.get(key), 120); if (value) result[key] = value;
    });
    return result;
  }
  function readExposure() {
    try {
      var value = JSON.parse(sessionStorage.getItem(storageKey));
      if (value && value.page_path === PAGE && valid(value.exposure_id)) return value;
    } catch (_) {}
    return null;
  }
  function ensureExposure() {
    if (exposure) return exposure;
    exposure = readExposure() || { exposure_id: id('els_'), page_path: PAGE, started_at: new Date().toISOString() };
    try { sessionStorage.setItem(storageKey, JSON.stringify(exposure)); } catch (_) {}
    return exposure;
  }
  function storedId(key) {
    try { var value = localStorage.getItem(key); if (/^efk_[a-f0-9]{32}$/i.test(value || '')) return value; } catch (_) {}
    var value = id('efk_');
    try { localStorage.setItem(key, value); } catch (_) {}
    return value;
  }
  function entry() {
    try {
      var value = JSON.parse(sessionStorage.getItem(entryStorageKey));
      if (value && /^efk_[a-f0-9]{32}$/i.test(value.entry_session_id || '') && typeof value.landing_path === 'string') return value;
    } catch (_) {}
    var value = { entry_session_id: id('efk_'), landing_path: PAGE, started_at: new Date().toISOString() };
    try { sessionStorage.setItem(entryStorageKey, JSON.stringify(value)); } catch (_) {}
    return value;
  }
  function joinContext() {
    var first = entry();
    return { entry_session_id: first.entry_session_id, visitor_id: storedId(visitorStorageKey), landing_path: first.landing_path };
  }
  function base(extra) {
    var e = ensureExposure(), join = joinContext(), distinct = null, session = null;
    try { distinct = w.posthog.get_distinct_id(); session = w.posthog.get_session_id(); } catch (_) {}
    var props = Object.assign({
      engagement_contract_version: VERSION, exposure_id: e.exposure_id, page_path: PAGE,
      entry_session_id: join.entry_session_id, elementi_visitor_id: join.visitor_id, landing_path: join.landing_path,
      storefront_session_id: valid(session) ? session : null,
      visitor_id: valid(distinct) ? distinct : null,
      device_type: device(), browser_family: browser(), referrer_host: referrerHost(),
      navigation_type: (performance.getEntriesByType('navigation')[0] || {}).type || 'unknown',
      is_internal: false, is_bot: false, analytics_allowed: true
    }, utm(), extra || {});
    return props;
  }
  function capture(name, props, onceKey) {
    if (!usable() || (onceKey && sent[onceKey])) return false;
    try { w.posthog.capture(name, base(props)); if (onceKey) sent[onceKey] = true; return true; } catch (_) { return false; }
  }
  function pagePosition(el) {
    var top = Math.max(0, el.getBoundingClientRect().top + w.scrollY), height = Math.max(document.documentElement.scrollHeight - w.innerHeight, 1), pct = top / height;
    return pct < 0.25 ? 'above_fold' : pct < 0.6 ? 'mid_page' : 'lower_page';
  }
  function sectionName(el) {
    var section = el.closest('section[id], [id^="shopify-section-"]');
    if (!section) return 'unsectioned';
    var raw = section.id || '';
    raw = raw.replace(/^shopify-section-[^-]+--/, '').replace(/__.+$/, '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 80);
    return raw || 'unsectioned';
  }
  function productForm(form) {
    try { return new URL(form.getAttribute('action') || '', w.location.origin).pathname === '/cart/add'; } catch (_) { return false; }
  }
  function variant(form) { var el = form.querySelector('input[name="id"],select[name="id"]'); return el && valid(String(el.value || '')) ? String(el.value) : 'unknown'; }
  function decorate(form) {
    if (!productForm(form) || !usable()) return;
    form.querySelectorAll('input[data-elementi-engagement-join]').forEach(function (input) { input.remove(); });
    var join = joinContext(), properties = Object.assign({
      _elementi_contract: 'elementi-site-v1',
      _elementi_entry_session_id: join.entry_session_id,
      _elementi_visitor_id: join.visitor_id,
      _elementi_landing_path: join.landing_path,
      _elementi_page_path: PAGE,
      _elementi_captured_at: new Date().toISOString(),
      _elementi_engagement_contract: VERSION,
      _elementi_exposure_id: ensureExposure().exposure_id,
      _elementi_page_path: PAGE,
      _elementi_browser: browser(),
      _elementi_device: device(),
      _elementi_referrer_host: referrerHost() || '',
      _elementi_test: 'false'
    }, Object.keys(utm()).reduce(function (memo, key) { memo['_elementi_' + key] = utm()[key]; return memo; }, {}));
    Object.keys(properties).forEach(function (key) {
      var input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + key + ']'; input.value = properties[key]; input.dataset.elementiEngagementJoin = 'true'; form.appendChild(input);
    });
  }
  function trackSections() {
    if (!('IntersectionObserver' in w)) return;
    var observed = 0, observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var name = sectionName(entry.target), key = 'section:' + name;
        capture('elementi_content_section_viewed', { section_id: name, viewport_position: pagePosition(entry.target) }, key);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('main section[id], main [id^="shopify-section-"]').forEach(function (node) { if (observed++ < 24) observer.observe(node); });
  }
  function trackOfferViews() {
    if (!('IntersectionObserver' in w)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var form = entry.target;
        capture('elementi_product_offer_viewed', { product_variant_id: variant(form), offer_position: pagePosition(form), section_id: sectionName(form) }, 'offer:' + variant(form) + ':' + sectionName(form));
        observer.unobserve(form);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('form').forEach(function (form) { if (productForm(form)) observer.observe(form); });
  }
  function scroll() {
    var y = Math.max(0, w.scrollY || 0), max = Math.max(document.documentElement.scrollHeight - w.innerHeight, 1), value = Math.round((y / max) * 100);
    maxScroll = Math.max(maxScroll, Math.min(100, Math.max(0, value)));
    [25, 50, 75, 90].forEach(function (threshold) { if (maxScroll >= threshold) capture('elementi_scroll_depth_reached', { depth_percent: threshold }, 'scroll:' + threshold); });
    var delta = y - scrollSignal.lastY;
    if (Math.abs(delta) >= 80) {
      var direction = delta > 0 ? 'down' : 'up';
      if (scrollSignal.direction && scrollSignal.direction !== direction && Math.abs(y - scrollSignal.directionalStartY) >= 300 && scrollSignal.reversals < 4) {
        scrollSignal.reversals += 1;
        capture('elementi_scroll_reversal_observed', { from_direction: scrollSignal.direction, to_direction: direction, depth_percent: Math.min(100, Math.max(0, value)), reversal_number: scrollSignal.reversals }, 'scroll-reversal:' + scrollSignal.reversals);
        scrollSignal.directionalStartY = y;
      } else if (!scrollSignal.direction || scrollSignal.direction !== direction) {
        scrollSignal.directionalStartY = y;
      }
      scrollSignal.direction = direction;
      scrollSignal.lastY = y;
    }
  }
  function controlType(el) {
    if (el.matches('a[href]')) return 'link';
    if (el.matches('summary')) return 'summary';
    if (el.matches('button')) return 'button';
    return 'role_button';
  }
  function watchUnresolvedControlClick(el) {
    if (unresolvedControlClicks >= 3 || !el || !el.matches || !el.matches('a[href], button, summary, [role="button"]')) return;
    if (el.matches('[disabled], .ph-no-capture, [data-ph-no-capture], .ph-no-deadclick')) return;
    var form = el.closest && el.closest('form');
    if (form && productForm(form)) return;
    var startPath = w.location.pathname, startY = w.scrollY || 0, changed = false;
    var observer = new MutationObserver(function () { changed = true; });
    try { observer.observe(document.documentElement, { childList: true, subtree: true }); } catch (_) { return; }
    w.setTimeout(function () {
      observer.disconnect();
      if (changed || document.hidden || w.location.pathname !== startPath || Math.abs((w.scrollY || 0) - startY) >= 24 || unresolvedControlClicks >= 3) return;
      unresolvedControlClicks += 1;
      capture('elementi_unresolved_control_click_observed', { control_type: controlType(el), section_id: sectionName(el), viewport_position: pagePosition(el), observation_number: unresolvedControlClicks }, 'unresolved-control:' + unresolvedControlClicks);
    }, 1400);
  }
  function performanceObservers() {
    try { new PerformanceObserver(function (list) { list.getEntries().forEach(function (entry) { performance.lcp = Math.round(entry.startTime); }); }).observe({ type: 'largest-contentful-paint', buffered: true }); } catch (_) {}
    try { new PerformanceObserver(function (list) { list.getEntries().forEach(function (entry) { if (!entry.hadRecentInput) performance.cls += entry.value; }); }).observe({ type: 'layout-shift', buffered: true }); } catch (_) {}
    try { new PerformanceObserver(function (list) { list.getEntries().forEach(function (entry) { performance.inp = Math.max(performance.inp || 0, Math.round(entry.duration || 0)); }); }).observe({ type: 'event', buffered: true, durationThreshold: 40 }); } catch (_) {}
  }
  function start() {
    if (!usable()) return false;
    capture('elementi_storefront_exposure', { entry_timestamp: ensureExposure().started_at }, 'exposure');
    document.querySelectorAll('form').forEach(decorate); trackSections(); trackOfferViews(); performanceObservers(); scroll();
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!productForm(form)) return;
      decorate(form);
      capture('elementi_cart_add_submitted', { product_variant_id: variant(form), offer_position: pagePosition(form), section_id: sectionName(form), direct_checkout_intent: /\/checkout(?:$|[?#])/.test(String((form.querySelector('[name="return_to"]') || {}).value || '')) });
    }, true);
    document.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('a[href], button, summary, [role="button"]');
      if (target) watchUnresolvedControlClick(target);
      var button = event.target.closest && event.target.closest('form button[type="submit"], a[href]'); if (!button) return;
      var form = button.closest && button.closest('form');
      if (form && productForm(form)) capture('elementi_product_cta_clicked', { product_variant_id: variant(form), offer_position: pagePosition(button), section_id: sectionName(button) });
      if (button.matches('a[href]')) { var url = new URL(button.href, w.location.origin); if (url.origin === w.location.origin && (/^\/(?:cart|checkout)/.test(url.pathname) || url.hash)) capture('elementi_navigation_clicked', { destination_type: url.hash ? 'anchor' : url.pathname.indexOf('/checkout') === 0 ? 'checkout' : 'cart', destination_path: url.pathname, section_id: sectionName(button) }); }
    }, true);
    document.addEventListener('toggle', function (event) { var target = event.target; if (target.matches && target.matches('details') && target.open) capture('elementi_accordion_opened', { section_id: sectionName(target), accordion_position: Array.prototype.indexOf.call(document.querySelectorAll('details'), target) + 1 }); }, true);
    w.addEventListener('scroll', scroll, { passive: true });
    w.addEventListener('pagehide', function () { capture('elementi_page_performance_observed', { max_scroll_percent: maxScroll, lcp_ms: performance.lcp, cls_milli: Math.round(performance.cls * 1000), inp_ms: performance.inp }, 'performance'); });
    return true;
  }
  function boot(attempt) { if (start()) return; if ((attempt || 0) < 30 && !SENSITIVE && !internal()) w.setTimeout(function () { boot((attempt || 0) + 1); }, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }, { once: true }); else boot(0);
  w.ElementiPostHogEngagement = { start: start, status: function () { return { version: VERSION, page_path: PAGE, eligible: usable(), exposure_id: exposure && exposure.exposure_id || null }; } };
})(window);
